/* Untrusted text is sanitized before parsing for diffs or inserting into a page.
 * Keep the formatting policy aligned with App\Support\SafeTextHtml. */
(function () {
    'use strict';

    var purifier = window.DOMPurify;
    var formatClass = /^(?:ql-align-(?:center|right|justify)|ql-indent-[1-8]|ql-direction-rtl|diff-added|diff-removed)$/;
    var options = {
        ALLOWED_TAGS: ['p', 'br', 'div', 'span', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
            'blockquote', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
            'pre', 'code', 'sub', 'sup', 'mark', 'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th'],
        ALLOWED_ATTR: ['class'],
        ALLOW_DATA_ATTR: false,
        ALLOW_ARIA_ATTR: false,
        RETURN_TRUSTED_TYPE: false
    };

    if (purifier && purifier.isSupported) {
        purifier.addHook('uponSanitizeAttribute', function (node, data) {
            if (data.attrName !== 'class') return;
            data.attrValue = data.attrValue.split(/\s+/).filter(function (name) {
                return formatClass.test(name);
            }).join(' ');
            if (!data.attrValue) data.keepAttr = false;
        });
    }

    function sanitize(value) {
        var source = String(value == null ? '' : value);
        if (purifier && purifier.isSupported) return purifier.sanitize(source, options);
        // A blocked/missing vendor script must never make the unsafe path active.
        return source.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    window.SafeTextHtml = { sanitize: sanitize };
}());
